import { Link } from "react-router-dom";
import styled from "styled-components";
import { Breakpoints } from "styles/breakpoints";
import colours from "styles/colours";
import fonts, { fontWeights } from "styles/fonts";

export const ArrowCircle = styled.span`
  background-color: ${colours.white};
  color: ${colours.elexonBlue};
  border-radius: 50%;
  width: 1.5em;
  aspect-ratio: 1;
  display: inline-grid;
  place-items: center;
  font-size: ${fonts.small};
  cursor: inherit;
  transition: color 350ms ease-in-out, background-color 350ms ease-in-out;
`;

const baseStyles = `
  display: inline-flex;
  align-items: center;
  color: ${colours.white};
  text-transform: none;
  font-weight: ${fontWeights.bold};
  cursor: pointer;
  text-decoration: none;

  &:hover,
  &:focus {
    color: ${colours.white};
  }

  &:hover ${ArrowCircle}, &:focus ${ArrowCircle} {
    background-color: ${colours.elexonGreen};
    color: ${colours.elexonBlack};
  }
`;

export const DesktopLink = styled(Link)`
  ${baseStyles}
  font-size: 1em;
  letter-spacing: 0.15em;
  gap: 20px;
  padding-right: 75px;

  @media (max-width: ${Breakpoints.Medium}) {
    letter-spacing: unset;
  }

  @media (max-width: ${Breakpoints.Small}) {
    display: none;
  }
`;

export const MobileLink = styled(Link)`
  display: none;

  @media (max-width: ${Breakpoints.Small}) {
    ${baseStyles}
    font-size: 0.75em;
    letter-spacing: 0.15em;
    gap: 8px;
  }
`;
